'use client'
import { Dithering } from '@paper-design/shaders-react'

import { ShaderIsland } from '@/components/ui/shader-island'

interface DitherPaperProps {
  waveSpeed?: number
  waveFrequency?: number
  waveAmplitude?: number
  waveColor?: [number, number, number]
  colorNum?: number
  pixelSize?: number
  disableAnimation?: boolean
  enableMouseInteraction?: boolean
  mouseRadius?: number
}

export default function DitherPaper({
  waveSpeed = 0.05,
  waveColor = [0.5, 0.5, 0.5],
  colorNum = 4,
  pixelSize = 2,
  disableAnimation = false,
}: DitherPaperProps) {
  const rgbToHex = (rgb: [number, number, number]) => {
    const r = Math.round(rgb[0] * 255)
    const g = Math.round(rgb[1] * 255)
    const b = Math.round(rgb[2] * 255)
    return `#${r.toString(16).padStart(2, '0')}${g.toString(16).padStart(2, '0')}${b.toString(16).padStart(2, '0')}`
  }

  const colorFront = rgbToHex(waveColor)
  const colorBack = '#ffffff00'
  const ditherType = colorNum <= 5 ? '4x4' : '8x8'

  return (
    <div className="h-full w-full">
      <ShaderIsland>
        <Dithering
          width="100%"
          height="100%"
          colorBack={colorBack}
          colorFront={colorFront}
          shape="wave"
          type={ditherType}
          size={pixelSize}
          speed={disableAnimation ? 0 : waveSpeed}
          scale={0.8}
          fit="cover"
        />
      </ShaderIsland>
    </div>
  )
}
